import { indicateWheatType } from '@/modules/common/helpers/wheat-type.helper';
import { OfferDetails } from '@/modules/mixing/ts/buyers-prices.types';
import { IInitialFormState } from '@/modules/seller-account/hooks/use-add-offer.hook';
import { notification } from 'antd';
import { useCompactItemContext } from 'antd/es/space/Compact';
import { fetchBuyerOffersFx, updateBuyerOfferFx } from '../store/offers.store';

export const updateBuyerOffer = async ({
  date,
  offerToEdit,
  formState,
  buyerInfo,
  setOfferToEdit,
  closeFn,
  indicatedClass,
}: IUpdateBuyerPointArgs) => {
  console.log(date);
  try {
    //const offsetMinutes = new Date().getTimezoneOffset();
    const unixTimestamp =
      new Date(
        date.year,
        date.month - 1,
        date.day,
        date.hours,
        date.minutes,
      ).getTime() /
        1000 
        // - offsetMinutes * 60;
    if (offerToEdit) {
      const res: any = await updateBuyerOfferFx({
        id: formState.id,
        year: String(formState.year),
        gluten: String(formState.gluten),
        idk: String(formState.idk),
        clop: String(formState.clop),
        protein: String(formState.protein),
        cp: String(formState.cp),
        nature: String(formState.nature),
        humidity: String(formState.humidity),
        weed: String(formState.weed),
        admixture_other_cereals: String(formState.admixtureOtherCereals),
        wheat_different_type: String(formState.wheatDifferentType),
        price: String(formState.buyingPrice),
        // expiration_offer: String(unixTimestamp),
        wheat_class: indicatedClass > 0 ? String(indicatedClass) : String(formState.wheatClass),
        wheat_type: String(
          indicateWheatType(String(formState.sort), String(formState.type)),
        ),
        pickup: formState.pickup,
        expiration_offer: String(unixTimestamp),
        class: `${indicatedClass > 0 ? String(indicatedClass) : String(formState.wheatClass)}-класс`,
        //type: '',
      });
      if ('error' in res) {
        try {
          const errorRes = res as any;
          const errorArray = Object.keys(errorRes.error.errors).reduce(
            (result, key) => {
              return result.concat(errorRes.error.errors[key]);
            },
            [],
          );
          if (errorArray && errorArray.length > 0) {
            errorArray.map((item) => notification.error({ message: item }));
            return;
          }
        } catch (err) {
          return notification.error({
            message: 'Непредвиденная ошибка. Попробуйте позже.',
          });
        }
      }
      notification.success({ message: 'Предложение успешно обновлено в системе!' });
      await fetchBuyerOffersFx();
      setOfferToEdit(null);
      closeFn();
    }
    return;
  } catch (err: any) {
    const res = err.body && await err.json();
    return res.error
      ? notification.error({
          message: res.error,
        })
      : notification.error({
          message: `Непредвиденная ошибка. Попробуйте позже.`,
        });
  }
};

export interface IUpdateBuyerPointArgs {
  date: {
    year: number;
    month: number;
    day: number;
    hours: number;
    minutes: number;
  };
  closeFn: () => void;
  formState: IInitialFormState;
  buyerInfo: any;
  offerToEdit: OfferDetails;
  setOfferToEdit: (val: OfferDetails | null) => void;
  indicatedClass: number
}
